enum GdprStatus {
    Allowed = '1',
    Declined = '0'
}

export default GdprStatus;